export default "__VITE_ASSET__Dz3T7XbT__"